// Assume this secret is injected securely into your page by your server.

import {Log} from '../log';
import {FALL_LOGS_TOKEN} from './constants';
import {FallbackLog} from './fallbackLogType';

// Helper function to convert ArrayBuffer to a hexadecimal string.
function bufferToHex(buffer: ArrayBuffer) {
  const bytes = new Uint8Array(buffer);
  return Array.from(bytes)
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

// Function to compute the HMAC signature for given data.
export async function getPayloadSignature(data: Partial<FallbackLog>) {
  try {
    const encoder = new TextEncoder();
    // Import the secret key for use with HMAC-SHA256.
    const key = await crypto.subtle.importKey(
      'raw',
      encoder.encode(FALL_LOGS_TOKEN),
      {name: 'HMAC', hash: 'SHA-256'},
      false,
      ['sign', 'verify'],
    );

    const signatureBuffer = await crypto.subtle.sign(
      'HMAC',
      key,
      encoder.encode(JSON.stringify(data)),
    );

    // Convert the signature to a hex string.
    return bufferToHex(signatureBuffer);
  } catch (error) {
    // skipping logging the error in local dev since the crypto.subtle method only works for secure domains, and will throw many warnings
    // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto
    if (process.env.NODE_ENV !== 'development') {
      Log.warn('@aboutyou/mlm', 'Failed to compute the signature', {error});
    }
    return '';
  }
}
